/* Browup cart page - group removal.

   The kit can occupy more than one cart line at the same time: Shopify splits a
   line when a Buy-X-Get-Y discount covers only part of the quantity, so a
   "Buy 2 Get 1 FREE" cart holds one paid line and one free line of the same
   variant. Removing the paid line used to leave the free one behind, which then
   re-priced itself at full price - the shopper pressed "remove", the kit stayed,
   and nothing they did could clear it.

   Any request that would zero out a kit line is rewritten into a single
   /cart/update.js that zeroes every kit line at once. One request matters: the
   cart page addresses lines by index, so mutating the cart first would
   invalidate the index the theme is about to send. */
(function () {
  'use strict';

  var CFG = window.BROWUP_CART_GROUP || {};
  var PRODUCT = Number(CFG.productId || 0);
  if (!PRODUCT) return;

  var OF = window.fetch.bind(window);

  function getCart() {
    return OF('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function bodyOf(init) {
    if (!init || !init.body) return null;
    if (typeof init.body === 'string') {
      try { return JSON.parse(init.body); } catch (e) { /* form encoded */ }
      var o = {};
      try { new URLSearchParams(init.body).forEach(function (v, k) { o[k] = v; }); } catch (e) { return null; }
      return o;
    }
    if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
      var f = {};
      init.body.forEach(function (v, k) { f[k] = v; });
      return f;
    }
    return null;
  }

  function lineFor(items, body) {
    if (body.line !== undefined) return items[Number(body.line) - 1] || null;
    var id = body.id;
    var hit = null;
    items.forEach(function (it, i) {
      if (hit) return;
      if (String(it.key) === String(id)) hit = it;
      else if (String(it.variant_id) === String(id)) hit = it;
      else if (String(i + 1) === String(id)) hit = it;
    });
    return hit;
  }

  /* Returns an updates map when this request removes a kit line, else null. */
  function plan(path, body) {
    if (!body) return Promise.resolve(null);
    return getCart().then(function (cart) {
      var items = cart.items || [];
      var own = {};
      var removesKit = false;
      var targetVariant = null;

      if (/\/cart\/change/.test(path)) {
        if (Number(body.quantity) !== 0) return null;
        var target = lineFor(items, body);
        if (!target || target.product_id !== PRODUCT) return null;
        removesKit = true;
        targetVariant = target.variant_id;
      } else if (/\/cart\/update/.test(path)) {
        var up = body.updates;
        if (!up) return null;
        if (Array.isArray(up)) {
          items.forEach(function (it, i) {
            if (up[i] === undefined) return;
            own[it.key] = Number(up[i]);
            if (it.product_id === PRODUCT && Number(up[i]) === 0) { removesKit = true; targetVariant = it.variant_id; }
          });
        } else {
          Object.keys(up).forEach(function (k) {
            own[k] = Number(up[k]);
            items.forEach(function (it) {
              if (it.product_id !== PRODUCT) return;
              if (String(it.key) === String(k) || String(it.variant_id) === String(k)) {
                if (Number(up[k]) === 0) { removesKit = true; targetVariant = it.variant_id; }
              }
            });
          });
        }
      } else {
        return null;
      }

      if (!removesKit) return null;
      items.forEach(function (it) {
        if (it.product_id !== PRODUCT) return;
        // Same variant only - a two-colour cart must not lose the colour the
        // shopper is keeping just because they removed the other one.
        if (targetVariant !== null && it.variant_id !== targetVariant) return;
        own[it.key] = 0;
      });
      return own;
    }).catch(function () { return null; });
  }

  window.fetch = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) { /* noop */ }
    var path = String(url).split('?')[0];
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();

    if (method === 'POST' && /\/cart\/(change|update)(\.js)?$/.test(path)) {
      var args = arguments;
      var body = bodyOf(init);
      return plan(path, body).then(function (updates) {
        if (!updates) return OF.apply(window, args);
        var payload = { updates: updates };
        if (body && body.sections) payload.sections = body.sections;
        if (body && body.sections_url) payload.sections_url = body.sections_url;
        return OF('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
      });
    }
    return OF.apply(window, arguments);
  };
})();
